import React from "react";
import styles from "./styles/footerStyles.module.css";

const Footer = (props) => {
  return (
    <div className={styles.footer}>
      {/* <ToggleTheme {...props} /> */}
      <p></p>
    </div>
  );
};

export default Footer;
